export default __webpack_public_path__ + "static/media/gallery-wip-grenade_00.f0cbbb9d.jpg";